import { apiHost } from '../../utils/apiHost';
export const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost()}`;
};

// 'YYYY-MM-DD' -> '5 Okt 2026'
export const formatTanggal = (iso) => {
  if (!iso) return '-';
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
};

// Peringatan "segera berakhir" mulai tampil H-30 sebelum masa aktif habis.
export const HARI_PERINGATAN = 30;

// Ringkasan status dari { permanen, expired, sisaHari }.
export const labelStatus = (l) => {
  if (!l) return { text: '-', color: 'default' };
  if (l.permanen) return { text: 'Permanen', color: 'success' };
  if (l.expired) return { text: 'Expired', color: 'error' };
  if (l.sisaHari <= HARI_PERINGATAN) return { text: `Sisa ${l.sisaHari} hari`, color: 'warning' };
  return { text: `Aktif (${l.sisaHari} hari lagi)`, color: 'success' };
};

export const AKSI_LABEL = {
  perpanjang: 'Diperpanjang',
  persingkat: 'Dipersingkat',
  jadi_permanen: 'Dijadikan permanen',
  atur_masa_aktif: 'Masa aktif diatur',
  ganti_paket: 'Ganti paket',
  paket_dan_masa_aktif: 'Ganti paket & masa aktif',
  ubah: 'Diubah',
};
